// modules
import { Provider } from 'react-redux'
// components
import store from './redux'
import EmojiPickerRoot from '../components/main/emojiPicker.container'
import {
  dispatchToggleIsOpen,
  dispatchSetIsOpen,
} from '../components/main/emojiPicker.actions'

export const toggleEmojiPicker = () => dispatchToggleIsOpen()
export const closeEmojiPicker = () => dispatchSetIsOpen(false)

function EmojiPicker(props: any) {
  return (
    <Provider store={store}>
      <EmojiPickerRoot {...props} />
    </Provider>
  )
}

export default EmojiPicker
